import React, { useEffect, useState } from 'react';
import './starYearInit.css';

function StarYearInit(props) {

    return (
        <div className='page-content page-content-star'>
            <img src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/star-of-top-title.png" alt="img"/>
            <img src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/star-of-top-three-img.png" alt="img"/>
            <img src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/star-of-list-img-2.png" alt="img"/>
        </div>
    );
}

export default StarYearInit;
